// extracted by mini-css-extract-plugin
export var postTitle = "PostTitle-module--postTitle---touk";